import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IJob } from './job.model';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class JobService {

  private endpoint = "jobs";

  constructor(private apiService: ApiService) { }

  getJobs(pageNumber: number, pageSize: number) {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.apiService.getAllPageed<IJob>({
      Url: `${this.endpoint}/all`,
      Params: params
    });
  }

  getJobById(id: number) {
    return this.apiService.get<IJob>({
      Url: `${this.endpoint}/${id}`,
    });
  }

  createJob(jobData: any) {
    return this.apiService.post<object, IJob>({
      Url: `${this.endpoint}`,
      Body: jobData
    });
  }

  updateJob(jobId: number, job: any) {
    return this.apiService.put<object, IJob>({
      Url: `${this.endpoint}/${jobId}`,
      Body: job
    });
  }

  deleteJob(id: number) {
    return this.apiService.delete<object, object>({
      Url: `${this.endpoint}/${id}`,
      Body: {}
    });
  }

  incrementApplication(jobId: any) {
    throw new Error('Method not implemented.');
  }
}
